import { useMutation } from 'react-query';
import request from '../../../helpers/request';

const needAnswerChange = async ({ questionNoteId, needAnswer }) => {
  const data = await request.put(
    `/Question/note_need_answer`,
    {},
    'Не удалось изменить статус сообщения',
    'Error',
    '',
    { questionNoteId, needAnswer }
  );

  return data;
};

const useMsgNeedAnswerMutation = (options) => {
  return useMutation(
    ({ questionNoteId, needAnswer }) =>
      needAnswerChange({ questionNoteId, needAnswer }),
    options
  );
};

export default useMsgNeedAnswerMutation;
